import { KeyValueModel } from "model/api";
import { EnumTipoCobrancaRevenda } from "model/enums/enum-tipo-cobranca-revenda";

export const TipoCobrancaRevendaMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoCobrancaRevenda.ClienteFinal, "Cliente Final"),
    new KeyValueModel(EnumTipoCobrancaRevenda.Revenda, "Revenda"),
    new KeyValueModel(EnumTipoCobrancaRevenda.RevendaPagas, "Revenda Pagas")
];